export default "__VITE_ASSET__4f056ce2__"